import styled from "styled-components";
import theme from "../../Styles/theme";
interface InputProps {
    ativo: boolean;
  }
export const Container = styled.div<InputProps>`
  width: 40%;
  opacity: ${({ ativo }) => (ativo ? 1 : 0.5)};
`;

export const Header = styled.label`
  font-size: max(1vw, 12px);
  color: ${theme.colors.dark};
`;


export const Input = styled.input`
  width: 100%;
  border: none;
  background-color: ${theme.colors.light};
  padding: 2vh 1vw;
  color: ${theme.colors.dark};

  
  font-size: max(1vw, 12px);
  border-radius: 0.25rem;
`;
